/**!
 * Created by Leonardo Cheslacki on 05/06/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import PageController from './PageController';

import {HelpersIcon, HelpersPin} from './../helpers';

import WithType from './../helpers/WithType';

import config from '../../../../config';

const {default: {init: {frame}, view}} = config;

let _this = {};

/**
 *
 */
class PageCurrent extends PageController {
    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {};

        this.helpersIcon = HelpersIcon(this)({current_name: 'page'});

        _this = this;
    };

    $functions = {
        /**
         *
         * @param event
         */
        handle: function (event) {

        }
    };

    initCover = () => {
        const {current_name} = this.props;

        AllTap.$current_name = current_name;

        this.gotoAndStopFrame(this.get(), frame);

        this.pageIn();

        /**
         * Preloader
         */
        this.main.emit('process_end', {}, current_name);
    };

    initLocalization = () => {
        const 
            {current_name} = this.props,
            stagePaginate = AllTap.$stagePaginate({current_name: current_name});

        AllTap.$current_name = current_name;

        this.gotoAndStopFrame(this.get(), frame);

        this.pageIn();

        const {occ_map} = this.getFrame();

        const helpersPin = HelpersPin(this)({current_name: 'localization'});

        helpersPin.setColor(this.verifyField(occ_map, 'occ_effect.occ_round'), '0xDFA084');
        helpersPin.setColor(this.verifyField(occ_map, 'occ_effect.occ_animate.occ_round_first'), '0xDFA084');
        helpersPin.setColor(this.verifyField(occ_map, 'occ_effect.occ_animate.occ_round_second'), '0xDFA084');

        stagePaginate.initPaginate();

        // const {btn_tour, btn_hall, btn_video} = this.getFrame();

        // this.openTour(btn_tour, {
        //     name: 'salaCompleta',
        //     uri: 'http://vitorino-web.local/public/images/360/ambientes/salaCompleta'
        // });
        //
        // this.openExternal(btn_hall, {name: 'hall', uri: 'http://vitorino-web.local/public/images/360/ambientes/hall'});
        //
        // this.openVideo(btn_video, {name: 'video', uri: 'http://latest-web.local/public/media/example.mp4'});

        /**
         * Preloader
         */
        this.main.emit('process_end', {}, current_name);
    };

    initProject = () => {
        const 
            {current_name} = this.props

        this.$current_name = current_name;

        this.gotoAndStopFrame(this.get(), frame);

        this.pageIn();

        const {occ_map} = this.getFrame();

        const helpersPin = HelpersPin(this)({current_name: 'localization'});

        helpersPin.setColor(this.verifyField(occ_map, 'occ_effect.occ_round'), '0xDFA084');
        helpersPin.setColor(this.verifyField(occ_map, 'occ_effect.occ_animate.occ_round_first'), '0xDFA084');
        helpersPin.setColor(this.verifyField(occ_map, 'occ_effect.occ_animate.occ_round_second'), '0xDFA084');

        this.main.emit('process_end', {}, current_name);
    };
    initDifferences = () => {
        const 
            {current_name} = this.props,
            stagePaginate = AllTap.$stagePaginate({current_name: current_name});

        this.$current_name = current_name;

        this.gotoAndStopFrame(this.get(), frame);

        this.pageIn();

        const {occ_map} = this.getFrame();

        const helpersPin = HelpersPin(this)({current_name: 'diferenciais'});

        helpersPin.setColor(this.verifyField(occ_map, 'occ_effect.occ_round'), '0xDFA084');
        helpersPin.setColor(this.verifyField(occ_map, 'occ_effect.occ_animate.occ_round_first'), '0xDFA084');
        helpersPin.setColor(this.verifyField(occ_map, 'occ_effect.occ_animate.occ_round_second'), '0xDFA084');

        stagePaginate.initPaginate();

        this.main.emit('process_end', {}, current_name);
    };
    /**
     *
     * @param current_page
     */
    initPlants = (current_page) => {
        const
            _this_current = this.get(),
            {current_name} = this.props,
            stagePaginate = AllTap.$stagePaginate({current_name: current_name, current_page: current_page});

        AllTap.$current_name = current_name;

        this.gotoAndStopFrame(_this_current, frame);

        this.pageIn();

        this.helpersIcon.disabledAnimate(_this_current)(this.toNumber(current_page));

        const object = this.getCurrentIndex();

        const
            paginates = this.getObject(object, 'paginates'),
            paginate = this.getCurrentIndex(paginates) || this.getDefaultIndex(paginates),
            active_differential = this.verifyField(paginate, 'active.differential'),
            active_differential_enabled = this.verifyField(paginate, 'active.differential_enabled'),
            active_camera = this.verifyField(paginate, 'active.camera'),
            active_pin = this.verifyField(paginate, 'active.pin');

        if (active_differential) {
            const layerDifferential = AllTap.$layerDifferential({
                current_name: current_name,
                current_page: current_page,
                enabled: active_differential_enabled
            });
            layerDifferential.initDifferential();
            stagePaginate.setState({...stagePaginate.state, differential: layerDifferential});
        }

        if (active_camera) {
            const layerCamera = AllTap.$layerCamera({current_name: current_name, current_page: current_page});
            layerCamera.initCamera();
            stagePaginate.setState({...stagePaginate.state, camera: layerCamera});
        }

        if (active_pin) {
            const layerPin = AllTap.$layerPin({current_name: current_name, current_page: current_page});
            layerPin.initPin();
            stagePaginate.setState({...stagePaginate.state, pin: layerPin});
        }

        stagePaginate.initPaginate();

        /**
         * Preloader
         */
        this.main.emit('process_end', {}, current_name);
    };

    initGallery = () => {
        const {current_name} = this.props;

        AllTap.$current_name = current_name;

        this.gotoAndStopFrame(this.get(), frame);

        this.pageIn();

        /**
         * Preloader
         */
        this.main.emit('process_end', {}, current_name);
    };

    initImplantation = () => {
        const
            {current_name} = this.props,
            stagePin = AllTap.$stagePin({current_name: current_name});

        AllTap.$current_name = current_name;

        this.gotoAndStopFrame(this.get(), frame);

        this.pageIn();

        stagePin.initPin();

        /**
         * Preloader
         */
        this.main.emit('process_end', {}, current_name);
    };

    /**
     *
     * @param current_page
     */
    initDeployments = (current_page) => {
        const
            _this_current = this.get(),
            {current_name} = this.props,
            stagePaginate = AllTap.$stagePaginate({current_name: current_name, current_page: current_page}),
            stagePin = AllTap.$stagePin({current_name: current_name});

        AllTap.$current_name = current_name;

        this.gotoAndStopFrame(_this_current, frame);

        this.pageIn();

        this.helpersIcon.disabledAnimate(_this_current)(this.toNumber(current_page));

        const object = this.getCurrentIndex();

        const
            paginates = this.getObject(object, 'paginates'),
            paginate = this.getCurrentIndex(paginates) || this.getDefaultIndex(paginates);

        stagePin.props.xml = this.verifyField(paginate, 'xml');
        stagePin.props.content_text = this.verifyField(paginate, 'content_text');

        stagePaginate.initPaginate();

        stagePin.initPin();

        /**
         * Preloader
         */
        this.main.emit('process_end', {}, current_name);
    };

    initOrientation = () => {
        const
            {current_name} = this.props,
            stageSun = AllTap.$stageSun({current_name: current_name});

        AllTap.$current_name = current_name;

        this.gotoAndStopFrame(this.get(), frame);

        this.pageIn();

        stageSun.initSun();

        /**
         * Preloader
         */
        this.main.emit('process_end', {}, current_name);
    };

    initPlant = () => {
        const
            {current_name} = this.props,
            stageZoom = AllTap.$stageZoom({current_name: current_name});

        AllTap.$current_name = current_name;

        this.gotoAndStopFrame(this.get(), frame);

        this.pageIn();

        stageZoom.initZoom();

        /**
         * Preloader
         */
        this.main.emit('process_end', {}, current_name);
    };

    /**
     *
     */
    initViews = () => {
        const
            _this_current = this.get(),
            {current_name} = this.props,
            stagePaginate = AllTap.$stagePaginate({current_name: current_name}),
            stageView = AllTap.$stageView({current_name: current_name}),
            pad_number_frame = this.padWithLeadingZeros(view.frame, 2),
            pad_number_pav = this.padWithLeadingZeros(view.pav, 2),
            occ_pseudo_frame = this.verifyField(_this_current, `occ_pseudo_frame${pad_number_frame}`),
            occ_pseudo_pav = this.verifyField(_this_current, `occ_pseudo_pav${pad_number_pav}`),
            btn_frame = this.verifyField(_this_current, `btn_frame${pad_number_frame}`),
            btn_pav = this.verifyField(_this_current, `btn_pav${pad_number_pav}`);

        AllTap.$current_name = current_name;

        this.gotoAndStopFrame(this.get(), view.frame);

        this.pageIn();

        this.helpersIcon.disabledAnimate(_this_current)(view.frame, 'frame');

        this.helpersIcon.disabledAnimate(_this_current)(view.pav, 'pav');

        occ_pseudo_frame && (occ_pseudo_frame.visible = true);

        occ_pseudo_pav && (occ_pseudo_pav.visible = true);

        btn_frame && (btn_frame.visible = false);

        btn_pav && (btn_pav.visible = false);

        stagePaginate.initPaginate(true);

        stageView.initView();

        /**
         * Preloader
         */
        this.main.emit('process_end', {}, current_name);
    };

    initSlider = () => {
        const
            {current_name} = this.props,
            stageSlider = AllTap.$stageSlider({current_name: current_name});

        AllTap.$current_name = current_name;

        this.gotoAndStopFrame(this.get(), frame);

        this.pageIn();

        stageSlider.initSlider();

        /**
         * Preloader
         */
        this.main.emit('process_end', {}, current_name);
    };

    initRecord = () => {
        const
            {current_name} = this.props;

        AllTap.$current_name = current_name;

        this.gotoAndStopFrame(this.get(), frame);

        this.pageIn();

        /**
         * Preloader
         */
        this.main.emit('process_end', {}, current_name);
    };

    initSlide = () => {
        const
            _this_current = this.get(),
            {current_name} = this.props,
            stagePaginate = AllTap.$stagePaginate({current_name: current_name}),
            occ_pseudo_frame = this.verifyField(_this_current, 'occ_pseudo_frame01'),
            btn_frame = this.verifyField(_this_current, 'btn_frame01');

        AllTap.$current_name = current_name;

        this.gotoAndStopFrame(this.get(), frame);

        this.pageIn();

        this.helpersIcon.disabledAnimate(_this_current)(1, 'frame');

        occ_pseudo_frame && (occ_pseudo_frame.visible = true);

        btn_frame && (btn_frame.visible = false);

        stagePaginate.initPaginate(true);

        /**
         * Preloader
         */
        this.main.emit('process_end', {}, current_name);
    };
}

/**
 *
 * @type {{}}
 */
PageCurrent.propTypes = {
    current_name: PropTypes.string
};

/**
 *
 * @type {{}}
 */
PageCurrent.defaultProps = {
    current_name: null
};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(PageCurrent, {className: 'PageCurrent'});
